import { ViewModel,View, Component } from "binder"
import  { HorizontalLineView } from "./horizontalLine-view"

export class HorizontalLineViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new HorizontalLineView();
    }
    public getTypeId(): string {
        return "VM-745FE6F8-CF09-4CDA-B10B-5C798D76CF78"
    }
}
